// @ts-nocheck
import React, { useState } from "react";
import dayjs from "dayjs";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import useSWR from "swr";
import { httpClient } from "../../api/http";
import { MdDownload } from "react-icons/md";
import { FaCalendarAlt } from "react-icons/fa";
import toast from "react-hot-toast";
import "dayjs/locale/th";
import { useAuthContext } from "../../auth";
import { Navigate } from "react-router-dom";
import { useNewRedirect } from "../../utils/hooks";

export function Report() {
  const [startDate, setStartDate] = useState(new Date());
  const [startPdfDate, setStartPdfDate] = useState(new Date());
  const [startPeopleCountingDate, setStartPeopleCountingDate] = useState(new Date());
  const [rawDataFileFormat, setRawDataFileFormat] = useState("xlsx");
  const [peopleCountingFileFormat, setPeopleCountingFileFormat] = useState("xlsx");
  const { isLoggedIn, isGuest } = useAuthContext();
  const redirect = useNewRedirect();

  const minDate = new Date("2024-10-01");
  const maxDate = new Date();

  const download_csv = function (csv_data: any, format: string, date: Date) {
    const blob = new Blob([csv_data], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("href", url);
    dayjs.locale("th");
    a.setAttribute(
      "download",
      `ข้อมูลดิบเดือน${dayjs(date).format("MMMM_YYYY")}.${format}`
    );
    dayjs.locale("en");
    a.click();
  };
  const handleDownloadPdf = async () => {
    const formattedMonth = dayjs(startPdfDate).format("YYYY-MM");
    const downloadPromise = dayjs(startPdfDate).isBefore(dayjs('2025-01-01')) ? (
      httpClient.get(`/v1/thaihealth/download_report?month=${formattedMonth}`, {
        responseType: "blob",
      })
    ) : (
      httpClient.post(`/v1/thaihealth/generate_report?month=${formattedMonth}`, {}, {
        responseType: "blob",
      })
    )

    toast.promise(downloadPromise, {
      loading: "Downloading report...",
      success: "Report downloaded successfully",
      error: "Cannot download report, please contact AltoTech support",
    });

    try {
      const response = await downloadPromise;
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      dayjs.locale("th");
      a.download = `รายงานประจำเดือน${dayjs(startPdfDate).format(
        "MMMM_YYYY"
      )}.pdf`;
      dayjs.locale("en");
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDownloadCsv = async () => {
    const downloadPromise = httpClient.get(
      `https://alto-cero-core-backend-dxghfkd7eth9a7fb.southeastasia-01.azurewebsites.net/api/v1/thaihealth/download_raw_data/?output_type=${rawDataFileFormat}&month=${dayjs(
        startDate
      ).format("YYYY-MM")}`,
      { responseType: "blob" }
    );

    toast.promise(downloadPromise, {
      loading: "Downloading report...",
      success: "Report downloaded successfully",
      error: "Cannot download report, please contact AltoTech support",
    });

    try {
      const response = await downloadPromise;
      download_csv(response.data, rawDataFileFormat, startDate);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDownloadPeopleCountingData = async () => {
    const downloadPromise = httpClient.get(
      `https://alto-cero-core-backend-dxghfkd7eth9a7fb.southeastasia-01.azurewebsites.net/api/v1/thaihealth/download_people_counting_data/?output_type=${peopleCountingFileFormat}&month=${dayjs(
        startPeopleCountingDate
      ).format("YYYY-MM")}`,
      { responseType: "blob" }
    );

    toast.promise(downloadPromise, {
      loading: "Downloading report...",
      success: "Report downloaded successfully",
      error: "Cannot download report, please contact AltoTech support",
    });

    try {
      const response = await downloadPromise;
      download_csv(response.data, peopleCountingFileFormat, startPeopleCountingDate);
    } catch (error) {
      console.log(error);
    }
  };

  if (!isLoggedIn || isGuest) {
    return <Navigate to={`/login${redirect}`} replace />;
  }

  return (
    <div className="h-screen flex flex-col bg-[#F9FAFF]">
      <div className="px-4 flex w-full py-3 items-center">
        <div className="flex-1">
          <h1 className="inline text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#0E7EE4] to-[#14B8B4]">
            Report
          </h1>
        </div>
      </div>
      <div
        className="relative px-4 pb-7 flex-1 flex flex-col bg-[#F9FAFF]"
        style={{ height: "calc(100% - 75px)" }}
      >
        <div className="px-8 py-4">
          <div className="grid md:grid-cols-2 gap-6">
            {/* Raw Data Report Card */}
            <div className="bg-white rounded-xl shadow-md group hover:shadow-lg transition-shadow duration-300 border border-gray-100">
              <div className="p-6">
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-2xl font-semibold text-gray-800">
                    ข้อมูลดิบ (Raw data)
                  </h2>
                </div>

                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <label className="text-black2 font-medium text-[20px]">
                      เลือกเดือน
                    </label>
                    <div className="relative">
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        dateFormat="MMM yyyy"
                        showMonthYearPicker
                        minDate={minDate}
                        maxDate={maxDate}
                        className="w-60 px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent outline-none"
                      />
                      <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                        <FaCalendarAlt />
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center justify-between">
                    <label className="text-black2 font-medium text-[20px]">
                      รูปแบบไฟล์
                    </label>
                    <div className="relative">
                      <select
                        value={rawDataFileFormat}
                        onChange={(e) => setRawDataFileFormat(e.target.value)}
                        className="w-60 px-4 py-2 pr-8 border border-gray-200 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent outline-none bg-white appearance-none"
                      >
                        <option value="xlsx">ไฟล์ Excel</option>
                        <option value="csv">ไฟล์ csv</option>
                      </select>
                      <div className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none">
                        <svg
                          className="w-4 h-4 text-gray-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M19 9l-7 7-7-7"
                          ></path>
                        </svg>
                      </div>
                    </div>
                  </div>

                  <button
                    className="w-full bg-primary hover:bg-blue-600 text-white font-semibold py-3 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
                    onClick={() => handleDownloadCsv()}
                  >
                    <MdDownload />
                    ดาวน์โหลดข้อมูลดิบไฟล์{" "}
                    {rawDataFileFormat == "xlsx" ? "Excel" : "csv"}
                  </button>
                </div>
              </div>
            </div>

            {/* Executive Report Card */}
            <div className="bg-white rounded-xl shadow-md group hover:shadow-lg transition-shadow duration-300 border border-gray-100">
              <div className="p-6">
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-2xl font-semibold text-gray-800">
                    รายงานสำหรับผู้บริหาร
                  </h2>
                </div>

                <p className="text-black2 mb-6 text-[20px]">
                  ดาวน์โหลดรายงานสรุปสำหรับผู้บริหารพร้อมข้อมูลเชิงลึกและตัวชี้วัดที่สำคัญ
                </p>
                <div className="flex items-center justify-between">
                  <label className="text-black2 font-medium text-[20px]">
                    เลือกเดือน
                  </label>
                  <div className="relative">
                    <DatePicker
                      selected={startPdfDate}
                      onChange={(date) => setStartPdfDate(date)}
                      dateFormat="MMM yyyy"
                      minDate={minDate}
                      maxDate={maxDate}
                      showMonthYearPicker
                      className="w-60 px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent outline-none"
                    />
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                      <FaCalendarAlt />
                    </div>
                  </div>
                </div>

                <button
                  className="w-full bg-primary hover:bg-blue-600 text-white font-semibold py-3 px-4 rounded-lg transition-all duration-200 flex items-center justify-center gap-2 mt-[20px]"
                  onClick={() => handleDownloadPdf()}
                >
                  <MdDownload />
                  ดาวน์โหลดรายงานผู้บริหาร
                </button>
              </div>
            </div>

            {/* People Counting Data Card */}
            <div className="bg-white rounded-xl shadow-md group hover:shadow-lg transition-shadow duration-300 border border-gray-100">
              <div className="p-6">
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-2xl font-semibold text-gray-800">
                    ข้อมูลการนับจำนวนคน (People Counting)
                  </h2>
                </div>

                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <label className="text-black2 font-medium text-[20px]">
                      เลือกเดือน
                    </label>
                    <div className="relative">
                      <DatePicker
                        selected={startPeopleCountingDate}
                        onChange={(date) => setStartPeopleCountingDate(date)}
                        dateFormat="MMM yyyy"
                        showMonthYearPicker
                        minDate={minDate}
                        maxDate={maxDate}
                        className="w-60 px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent outline-none"
                      />
                      <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                        <FaCalendarAlt />
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center justify-between">
                    <label className="text-black2 font-medium text-[20px]">
                      รูปแบบไฟล์
                    </label>
                    <div className="relative">
                      <select
                        value={peopleCountingFileFormat}
                        onChange={(e) => setPeopleCountingFileFormat(e.target.value)}
                        className="w-60 px-4 py-2 pr-8 border border-gray-200 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent outline-none bg-white appearance-none"
                      >
                        <option value="xlsx">ไฟล์ Excel</option>
                        <option value="csv">ไฟล์ csv</option>
                      </select>
                      <div className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none">
                        <svg
                          className="w-4 h-4 text-gray-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M19 9l-7 7-7-7"
                          ></path>
                        </svg>
                      </div>
                    </div>
                  </div>

                  <button
                    className="w-full bg-primary hover:bg-blue-600 text-white font-semibold py-3 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
                    onClick={() => handleDownloadPeopleCountingData()}
                  >
                    <MdDownload />
                    ดาวน์โหลดข้อมูลการนับจำนวนคนไฟล์{" "}
                    {peopleCountingFileFormat == "xlsx" ? "Excel" : "csv"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
